<lin-layout-section title="{{ sectionTitle | translate }}" scrollable>
  @if (isLoaded) {
  <lin-document-form [document]="document" [driver]="driver" [documentSubject]="'driver'" [clientId]="clientId"></lin-document-form>
  } @if (!isLoaded) {
  <lin-spinner></lin-spinner>
  }
</lin-layout-section>
